export default __webpack_public_path__ + "static/media/esp.527231b4.svg";